import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SocketState } from './socket.reducer';

export const selectSocketState = createFeatureSelector<SocketState>('socket');
export const selectMessages = createSelector(
    selectSocketState,
    (state, uid) => {
        const messages = state.messages;
        const filtered = messages.filter(
            m => {
                return m.uid === uid
            }
        )
        return filtered.sort((a, b) => (a.sendTime > b.sendTime) ? 1 : -1);
    }
);
export const selectContacts = createSelector(
    selectSocketState,
    (state) => {
        const messages = state.messages;
        let result =  state.contacts.map(c => {
            const lastMessageText = messages.find(m => {
                return m.uid === c.id && m.sendTime === c.lastMessage
            })
            c.lastMessageText = lastMessageText?.context ? lastMessageText.context.replace(/<br>/g, '') : null;
            if (c.lastMessageText && (c.lastMessageText.endsWith('.jpg') || c.lastMessageText.endsWith('.jpeg') || c.lastMessageText.endsWith('.png'))) {
                c.lastMessageText = '[图片]';
            }
        
            return c;
        });
        return result;
    }
);
export const selectSettings = createSelector(
    selectSocketState,
    (state) => {
        return state.settings;
    }
);
export const selectBlocked = createSelector(
    selectSocketState,
    (state) => {
        return state.isblocked;
    }
);
export const selectLoadingMessages = createSelector(
    selectSocketState,
    (state) => {
        return state.loadingMessages;
    }
);
export const selectLoadingContacts = createSelector(
    selectSocketState,
    (state) => {
        return state.loadingContacts;
    }
);
export const selectedContact = createSelector(
    selectSocketState,
    (state) => {
        return state.selectedContact;
    }
);
export const selectEarliestMessage = createSelector(
    selectSocketState,
    (state) => {
        if (!state.selectedContact) {
            return [];
        }
        const messages = state.messages.filter(m => {
            return m.uid === state.selectedContact.id && !!m.id;
        }).sort((a, b) => (a.sendTime > b.sendTime) ? 1 : -1);

        return messages.length ? messages[0] : null;
    }
);

export const selectCurrentMessages = createSelector(
    selectSocketState,
    (state) => {
        if (!state.selectedContact) {
            return [];
        }
        const messages = state.messages.filter(m => {
            return m.uid === state.selectedContact.id;
        }).sort((a, b) => (a.sendTime > b.sendTime) ? 1 : -1);

        return messages;
    }
);

export const selectCurrentImages = createSelector(
    selectSocketState,
    (state) => {
        if (!state.selectedContact) {
            return [];
        }
        const messages = state.messages.filter(m => {
            return m.uid === state.selectedContact.id && m.messageType === 'image';
        }).sort((a, b) => (a.sendTime > b.sendTime) ? 1 : -1);

        return messages;
    }
);

export const selectCurrentMessagesGroupByDateTime = createSelector(
    selectSocketState,
    (state) => {
        if (!state.selectedContact) {
            return [];
        }
        let lastGroupName: any;
        let lastTimestamp: any;
        const messages = state.messages.filter(m => {
            return m.uid === state.selectedContact.id;
        }).sort((a, b) => (a.sendTime > b.sendTime) ? 1 : -1).reduce((groups, item) => {
            if (groups && Object.keys(groups).length === 0 && groups.constructor === Object) {
                lastGroupName = item.sendTime;
                groups[lastGroupName] = [item];
            } else {
                if (item.sendTime - lastTimestamp < 180) {
                    groups[lastGroupName] = [...groups[lastGroupName], item];
                } else {
                    lastGroupName = item.sendTime;
                    groups[lastGroupName] = [item];
                }
            }
            lastTimestamp = item.sendTime;
            return groups;
        }, {});

        return messages;
    }
);

export const selectLatestMessage = createSelector(
    selectSocketState,
    (state) => {
        return state.latestMessage;
    }
);

export const selectHasUnreadMessage = createSelector(
    selectSocketState,
    (state) => {
        return !!state.contacts.filter(c => c?.hasNew).length;
    }
);

export const selectConcatsHasUnreadMessage = createSelector(
    selectSocketState,
    (state) => {
        return state.contacts.filter(c => c.hasNew);
    }
);
